import { render, staticRenderFns } from "./yybIndex.vue?vue&type=template&id=084a2c8f"
import script from "./yybIndex.vue?vue&type=script&lang=js"
export * from "./yybIndex.vue?vue&type=script&lang=js"
import style0 from "./yybIndex.vue?vue&type=style&index=0&id=084a2c8f&prod&lang=css"
import style1 from "./yybIndex.vue?vue&type=style&index=1&id=084a2c8f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports